import PropTypes from 'prop-types'
import React from 'react'
import RepeatGroupCitizenField from '../question_fields/RepeatGroupCitizenField'

const Citizen = props => {
  const { index, name, baseName, question, disabled = false, margin, onChange } = props
  return (
    <RepeatGroupCitizenField
      index={index}
      {...question}
      manualRequest={question.manual_request}
      childrenAttributes={question.children_attributes}
      name={name}
      baseName={baseName}
      disabled={disabled}
      margin={margin}
      onChange={onChange}
    />
  )
}

const RepeatGroupQuestion = {
  Citizen,
  name: 'RepeatGroupQuestion'
}

export default RepeatGroupQuestion

Citizen.propTypes = {
  disabled: PropTypes.bool,
  index: PropTypes.number,
  margin: PropTypes.string,
  name: PropTypes.string,
  baseName: PropTypes.string,
  onChange: PropTypes.func,
  question: PropTypes.object
}
